export default __webpack_public_path__ + "static/any-device-7d599fedeb7d746768a418c52c2c7a27.webp";